import React, { useState, useRef, useEffect } from "react";
import { useBlogContext } from "../../fetchdata/BlogContext";

const OtpList = () => {
  const { IsUserData } = useBlogContext();
  const [showOtpList, setShowOtpList] = useState(false);
  const chatRef = useRef(null);
  const [position, setPosition] = useState({ bottom: 80, right: 20 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const hasOrders = IsUserData?.myorder?.length > 0;

  // ----- Drag Handlers -----
  const startDrag = (clientX, clientY) => {
    setDragging(true);
    const rect = chatRef.current.getBoundingClientRect();
    setOffset({
      x: clientX - rect.left,
      y: clientY - rect.top,
    });
  };

  const handleMouseDown = (e) => startDrag(e.clientX, e.clientY);
  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    startDrag(touch.clientX, touch.clientY);
  };

  const handleMove = (clientX, clientY) => {
    if (!dragging) return;
    const newRight =
      window.innerWidth - (clientX - offset.x + chatRef.current.offsetWidth);
    const newBottom =
      window.innerHeight - (clientY - offset.y + chatRef.current.offsetHeight);
    setPosition({
      right: Math.max(10, newRight),
      bottom: Math.max(10, newBottom),
    });
  };

  const handleMouseMove = (e) => handleMove(e.clientX, e.clientY);
  const handleTouchMove = (e) => {
    const touch = e.touches[0];
    handleMove(touch.clientX, touch.clientY);
  };

  const stopDrag = () => setDragging(false);

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", stopDrag);

      window.addEventListener("touchmove", handleTouchMove, { passive: false });
      window.addEventListener("touchend", stopDrag);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", stopDrag);

      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", stopDrag);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", stopDrag);

      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", stopDrag);
    };
  }, [dragging]);

  return (
    <>
      {/* Floating draggable chat icon */}
      <div
        ref={chatRef}
        className="otp-chat-icon d-flex align-items-center justify-content-center"
        style={{
          position: "fixed",
          bottom: position.bottom,
          right: position.right,
          zIndex: 9999,
          cursor: "grab",
        }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
        onClick={() => setShowOtpList(!showOtpList)}
      >
        <i
          className={`${
            hasOrders ? "ri-chat-unread-fill" : "ri-chat-4-fill"
          } fs-4 text-white`}
        ></i>
      </div>

      {/* OTP List Modal */}
      {showOtpList && hasOrders && (
        <div className="otp-list-container shadow border rounded p-2 bg-white">
          <h6 className="mb-2">Active Bookings</h6>
          <div className="d-flex flex-wrap">
            {IsUserData.myorder.map(
              (order) =>
                order.OTP && (
                  <div
                    key={order._id}
                    className="otp-box mb-2 me-2 border p-2 bg-light small rounded"
                  >
                    <p className="m-0">
                      Order Id: {order.orderId}{" "}
                      <span className="bg-success text-white py-1 px-2 ms-2 rounded">
                        OTP: {order.OTP}
                      </span>
                    </p>
                  </div>
                )
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default OtpList;